import { Injectable } from "@angular/core";
import { PublishPlanStatusEnum } from "@modules/api/publish-plan-status-enum.generated";
import { CompleteUrlBuilderService } from '@modules/common/services/complete-url-builder.service';
import { isCreationStep } from '@modules/publishing-shared/functions/is-creation-step';
import { isExecutionStep } from '@modules/publishing-shared/functions/is-execution-step';
import { isRollbackStep } from '@modules/publishing-shared/functions/is-rollback-step';

@Injectable({
    providedIn: 'root'
})
export class GetPublishDetailUrlService {
    constructor(
        private _completeUrlBuilderService: CompleteUrlBuilderService
    ) { }

    public getPublishDetailUrl(publishPlanStatus: PublishPlanStatusEnum, publishPlanId: string): string {
        //If the publish plan is in the middle of an action, return the URL for the status page.
        //Otherwise, return the URL for the data changes page.
        if (isCreationStep(publishPlanStatus) || publishPlanStatus == PublishPlanStatusEnum.BeginningPublishPlanCreation
            || isExecutionStep(publishPlanStatus)
            || isRollbackStep(publishPlanStatus)) {
            return this._completeUrlBuilderService.buildUrl(['PublishingCenter', 'Status', publishPlanId]);
        } else {
            return this._completeUrlBuilderService.buildUrl(['PublishingCenter', 'PublishDataChanges', publishPlanId]);
        }
    } 
}
